import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fw-bold text-danger d-block"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeslizarMovil',
    setup(__props) {
        const xs = computed(() => window.screen.width <= 576);
        return (_ctx, _cache) => {
            return (xs.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_1, "*Deslice la tabla hacia los lados para observar más información"))
                : _createCommentVNode("", true);
        };
    }
});
